export default Object.freeze({
    CREATED: 'CREATED',
    DECLINED: 'DECLINED',
    CANCELLED: 'CANCELLED',
    INSURANCE_AUTH_PENDING: 'INSURANCE_AUTH_PENDING',
    PATIENT_VISIT_PENDING: 'PATIENT_VISIT_PENDING',
    RESCHEDULE_REQUESTED: 'RESCHEDULE_REQUESTED',
    RESCHEDULE_AVAILABILITY_CHANGE: 'RESCHEDULE_AVAILABILITY_CHANGE',
    CONSULTATION_NOTES_PENDING: 'CONSULTATION_NOTES_PENDING',
    NO_SHOW: 'NO_SHOW',
    COMPLETED: 'COMPLETED',
    TIME_SLOTS_PROPOSED: 'TIME_SLOTS_PROPOSED',
    ACCEPTED: 'ACCEPTED',
    SCHEDULED: 'SCHEDULED',
    INACTIVE: 'INACTIVE',
    RESCHEDULE_REQUESTED_BY_PATIENT: 'RESCHEDULE_REQUESTED_BY_PATIENT',
    PATIENT_VISIT_PAST: 'PATIENT_VISIT_PAST',
    REFERRALS_POOL_RECEIVED: 'REFERRALS_POOL_RECEIVED',
    REFERRALS_POOL_RECEIVED_BY_PATIENT: 'REFERRALS_POOL_RECEIVED_BY_PATIENT',
    REFERRALS_POOL_SLOTS_PROPOSED: 'REFERRALS_POOL_SLOTS_PROPOSED',
    CREATED_BY_PATIENT: 'CREATED_BY_PATIENT',
    AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION',
    CLOSED: 'CLOSED',
})
